import React from 'react';
import { StatusBadge } from '../../ui/StatusBadge';
import { Project } from '../../../utils/openai-api';
import { ProjectSummaryItem } from '../types';

interface ProjectSummaryTableProps {
  projectSummary: ProjectSummaryItem[];
  onProjectClick: (project: Project) => void;
}

export const ProjectSummaryTable: React.FC<ProjectSummaryTableProps> = ({ projectSummary, onProjectClick }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
      <div className="px-2 sm:px-4 py-1.5 sm:py-2 border-b border-gray-200 dark:border-gray-700">
        <h2 className="text-xs sm:text-sm font-semibold text-gray-900 dark:text-white">Project Summary</h2>
      </div>
      <div className="overflow-x-auto custom-scrollbar">
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
          <thead className="bg-gray-50 dark:bg-gray-900">
            <tr>
              <th className="px-2 sm:px-3 py-1 sm:py-1.5 text-left text-[10px] sm:text-[11px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                Project Name
              </th>
              <th className="px-2 sm:px-3 py-1 sm:py-1.5 text-left text-[10px] sm:text-[11px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                Status
              </th>
              <th className="px-2 sm:px-3 py-1 sm:py-1.5 text-left text-[10px] sm:text-[11px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                Users
              </th>
              <th className="px-2 sm:px-3 py-1 sm:py-1.5 text-left text-[10px] sm:text-[11px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                API Keys
              </th>
              <th className="px-2 sm:px-3 py-1 sm:py-1.5 text-left text-[10px] sm:text-[11px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                Created
              </th>
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
            {projectSummary.map((projectSummaryItem, idx) => (
              <tr key={idx} className={idx % 2 === 0 ? 'bg-white dark:bg-gray-800' : 'bg-gray-50 dark:bg-gray-900'}>
                <td className="px-2 sm:px-3 py-1 sm:py-1.5 whitespace-nowrap text-xs font-medium text-gray-900 dark:text-white">
                  <button
                    onClick={() => onProjectClick(projectSummaryItem.project)}
                    className="text-gray-900 dark:text-white hover:text-gray-700 dark:hover:text-gray-300 hover:underline cursor-pointer font-medium transition-colors duration-200"
                    type="button"
                  >
                    {projectSummaryItem.name}
                  </button>
                </td>
                <td className="px-2 sm:px-3 py-1 sm:py-1.5 whitespace-nowrap text-xs text-gray-500 dark:text-gray-400">
                  <StatusBadge
                    status={projectSummaryItem.status}
                    variant={projectSummaryItem.status === 'active' ? 'emerald' : 'slate'}
                  />
                </td>
                <td className="px-2 sm:px-3 py-1 sm:py-1.5 whitespace-nowrap text-xs text-gray-500 dark:text-gray-400">
                  {projectSummaryItem.userCount}
                </td>
                <td className="px-2 sm:px-3 py-1 sm:py-1.5 whitespace-nowrap text-xs text-gray-500 dark:text-gray-400">
                  {projectSummaryItem.apiKeyCount}
                </td>
                <td className="px-2 sm:px-3 py-1 sm:py-1.5 whitespace-nowrap text-xs text-gray-500 dark:text-gray-400">
                  {projectSummaryItem.createdAt}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
